function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 17q-2.917 0-4.958-2.042Q3 12.917 3 10h1.5q0 2.271 1.615 3.885Q7.729 15.5 10 15.5t3.885-1.615Q15.5 12.271 15.5 10t-1.615-3.885Q12.271 4.5 10 4.5q-1.292 0-2.385.531-1.094.531-1.844 1.469H8V8H3V3h1.5v2.708q.958-1.25 2.385-1.979Q8.312 3 10 3q1.458 0 2.729.552 1.271.552 2.219 1.5t1.5 2.219Q17 8.542 17 10q0 1.458-.552 2.729-.552 1.271-1.5 2.219t-2.219 1.5Q11.458 17 10 17Zm2.083-4.167L9.25 10V6h1.5v3.375l2.396 2.396Z"
});

var SvgCached = function SvgCached(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCached, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cached.2381fb8d.svg";
export { ForwardRef as ReactComponent };